// color config
import { Col } from "antd";
import {
  textTitleDesc,
  textTitleHeader,
  textDescHeader,
  colorBackgroundBtnCameraProfile,
  colorIconCameraProfile,
  textTitleProfile,
  ColorPrimary,
  colorTextTitleMobile,
  textTitleMyLearningJourney,
} from "../../config/constant/color/index";
import { point } from "leaflet";

const styles = {
  themeToken: {
    fontFamily: "Roboto",
  },
  siderStyle:{
    lineHeight: "120px",
    color: textTitleDesc,
    borderRight:"1px solid #E5E5E6",
    boxShadow:"rgb(0 0 0 / 10%) 10px 7px 16px",
    zIndex:98
  },
  fontSize15: {
    fontSize: "15px",
  },
  textAlignLeft: {
    textAlign: "left",
  },
  colRightWrapperMobile: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    lineHeight: "normal",
  },
  imageLearningPoint: {
    width: "28px",
    height: "28px",
  },
  learningPointSkelWrapperMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    margin: "0 0px 0px 8px",
    lineHeight: "100%",
  },
  pointsMobile: {
    fontSize: "12px",
    fontWeight: "500",
    color: textTitleHeader,
  },
  textLearningPointsMobile: {
    fontSize: "10px",
    color: textDescHeader,
    textAlign: "left",
  },
  headerMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    backgroundColor: "#FFF8F4",
    borderBottom: "none",
    padding: "20px",
  },
  menuWrapperMobile: {
    padding: "18px 20px 20px 20px",
    textAlign: "left",
  },
  buttonCamera: {
    position: "absolute",
    right: 0,
    bottom: 0,
    backgroundColor: colorBackgroundBtnCameraProfile,
    opacity: "0.75",
    borderRadius: "50%",
    border: "none",
    width: "28px",
    height: "28px",
  },
  iconCamera: {
    fontSize: "17px",
    color: colorIconCameraProfile,
  },
  // specProfile: {
  //   marginLeft: "20px",
  // },
  userFullname: {
    fontSize: "18px",
    fontWeight: "500",
    color: ColorPrimary,
    lineHeight: "normal",
  },
  colRole: {
    marginRight: "20px",
  },
  valuePosition: {
    fontWeight: "500",
    fontSize: "12px",
    color: colorTextTitleMobile,
    lineHeight: "normal",
  },
  labelValue: {
    fontWeight: "500",
    fontSize: "12px",
    color: colorTextTitleMobile,
    pointerEvents: "none",
    textDecoration: "none",
    userSelect: "text",
  },
  chipCertificate: {
    width: "100%",
    borderColor: ColorPrimary,
    color: ColorPrimary,
    borderRadius: "20px",
    // fontSize: "12px",
    fontSize: "0.8em",
    fontWeight: "500",
    justifyContent: "left",
  },
  // heightAuto: {
  //   height: "auto",
  // },
  // marginLeftRight: {
  //   margin: "0 20px",
  // },
  labelProfile: {
    fontSize: "12px",
    fontWeight: "400",
    color: textTitleDesc,
    lineHeight: "normal",
    marginBottom: "4px",
  },
  titleProgramWrapper: {
    height: "38px",
    fontSize: "14px",
    fontWeight: "500",
    color: textTitleMyLearningJourney,
    textAlign: "left",
  },
  titleProgramMobile: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "1.4",
    width: "86%",
    left: "43%",
  },
  imageThumbnailMobile: {
    objectFit: "cover",
    borderRadius: "8px",
  },
};

export default styles;
